// import React from 'react';
// import { Link } from 'react-router-dom';
import './style.css';
// Import images
import AboutImg from '../../../assets/img/banner/WhatsApp Image 2025-06-12 at 04.17.07_8a45134e.jpg';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faHandsHelping, faHeart, faUsers } from '@fortawesome/free-solid-svg-icons';

// const stats = [
//   {
//     icon: faHandsHelping,
//     label: 'Expectant Moms',
//     value: '2354+',
//     color: '#FFA726',
//   },
//   {
//     icon: faHeart,
//     label: 'People Helped',
//     value: '3500+',
//     color: '#FF6B6B',
//   },
//   {
//     icon: faUsers,
//     label: 'Volunteers',
//     value: '500+',
//     color: '#7B1FA2',
//   },
// ];

const Forms = () => {
    return (
        <section className="who_we_are_section section_padding">
            <div className="container">
                <div className="">
                    <div className="">
                        <div className="who_we_are_img">

                            <iframe src="https://docs.google.com/forms/d/e/1FAIpQLSdGg5qRqxtZH1WU4hDEsj5GX24WwutmlPQue9N-KY7HYhqHdg/viewform?embedded=true" width="100%" height="1334" frameborder="0" marginheight="0" marginwidth="0">Loading…</iframe>
                 
                        </div>
                    </div>
                 
                </div>
            </div>
        </section>
    );
};

export default Forms;
